













import Component, { mixins } from "vue-class-component";
import { CallStatus, isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { $t } from "@/lib/i18nHelpers";
import { toTimePassed } from "@/lib/time";
import BaseIcon from "@/components/BaseIcon";
import MessageView from "../mixins/MessageView";

@Component({ name: "SystemMessageCall", components: { BaseIcon } })
export default class SystemMessageCall extends mixins(MessageView) {
  public get opponentMessage() {
    if (isCallMessageDetails(this.message.details)) {
      return this.message.details.callerId !== Number(this.authUserId);
    }
    return false;
  }

  public get text(): string {
    if (isCallMessageDetails(this.message.details)) {
      const status = this.message.details.status;
      if (status === CallStatus.ENDED) {
        return this.opponentMessage ? $t("{0} call", [$t("Incoming")]) : $t("{0} call", [$t("Outgoing")]);
      }
      if (this.opponentMessage) return $t("{0} call", [$t("Missed")]);
      if (status === CallStatus.CANCELLED) return $t("{0} call", [$t("Canceled")]);
      if (status === CallStatus.DECLINED) return $t("{0} call", [$t("Declined")]);
    }
    return "";
  }
  public get callDuration() {
    if (isCallMessageDetails(this.message.details) && this.message.details.startTime && this.message.details.endTime) {
      const duration =
        new Date(this.message.details.endTime).getTime() - new Date(this.message.details.startTime).getTime();
      return toTimePassed(duration);
    }
    return "";
  }
}
